import { RepositoryTab } from '@/features/Transition360/Repository/RepositoryTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/repository',
)({
    component: RepositoryTabRoute,
});

function RepositoryTabRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    return (
        <RepositoryTab projectId={projectId} projectAssetId={projectAssetId} />
    );
}
